import React from 'react'

const Home = ({ className }: { className?: string }) => {
    return (
        <svg className={className} fill="none" height="26" viewBox="0 0 26 26" width="26" xmlns="http://www.w3.org/2000/svg">
<path d="M16.25 19.4998H9.74999M23.439 14.0377L23.1367 16.1361C22.6092 19.8064 22.3448 21.6405 21.0719 22.7368C19.799 23.8332 17.9324 23.8332 14.1982 23.8332H11.8018C8.06757 23.8332 6.20099 23.8332 4.92807 22.7368C3.65516 21.6405 3.39082 19.8064 2.86324 16.1361L2.56099 14.0377C2.14932 11.1809 1.94349 9.752 2.52957 8.53109C3.11566 7.31017 4.36149 6.567 6.85424 5.08284L8.35466 4.18909C10.6167 2.84034 11.7498 2.1665 13 2.1665C14.2502 2.1665 15.3822 2.84034 17.6453 4.18909L19.1457 5.08284C21.6374 6.567 22.8843 7.31017 23.4704 8.53109" stroke="currentColor" strokeLinecap="round" strokeWidth="1.625"></path>
</svg>
    )
}

export default Home
